export const pricing = {
  breadcrumb: "Tarifs",
  title: "Tarifs simples et flexibles",
  subtitle: "Une commission unique de 5%, payée par qui vous voulez.",
  whoPays: {
    title: "Qui paie les frais ?",
    traveler: {
      label: "Option 1 : Le voyageur paie (Recommandé)",
      description:
        "Vous recevez 100% de votre prix. Le voyageur ajoute 5% de frais de service.",
      badge: "Par défaut",
    },
    host: {
      label: "Option 2 : L'hôte paie (Pro)",
      description:
        "Vous payez les 5%. Prix affiché plus bas pour le voyageur, idéal pour les sociétés.",
      badge: "Option Pro",
    },
  },
  guarantee: "Transparence totale garantie",
  perYear: "/an",
  choose: "Choisir",
  popular: "Le plus populaire",
  plans: {
    traveler: {
      name: "Voyageur",
      description: "Pour explorer le monde à moindre coût",
      price: "5%",
      period: "de commission",
      features: [
        "Accès à tous les logements",
        "Frais de service réduits (5%)",
        "Assistance 7j/7",
        "Pas de frais cachés",
      ],
    },
    host: {
      name: "Hôte",
      description: "Pour louer sans frais et échanger",
      price: "0%",
      period: "de commission",
      features: [
        "0% de commission sur vos revenus",
        "Accès aux échanges gratuits entre hôtes",
        'Badge "Prix Équitable" disponible',
        "Visibilité accrue",
        "Assistance prioritaire",
      ],
    },
  },
  fairPrice: {
    title: "Programme Prix Juste",
    description: "Jouez le jeu, gagnez plus.",
    benefit1: "Badge 'Prix Juste' visible",
    benefit2: "Priorité dans les résultats",
    benefit3: "Bonus de points d'échange",
    condition:
      "Proposez un tarif au moins 10% moins cher que sur les autres plateformes.",
  },
  taxAdvantage: {
    title: "Avantage Fiscal & Pro",
    text: "Les frais de 5% peuvent être déductibles de vos charges si vous êtes une société. Le modèle 0% simplifie la comptabilité des particuliers. Consultez votre expert-comptable.",
  },
  hostExchange: {
    title: "Système d'Échange Hôte",
    description: "Échangez vos nuits gagnées contre des séjours gratuits.",
    free: "Gratuit (0€)",
    community: "Réservé aux membres vérifiés",
  },
  comparison: {
    title: "Pourquoi c'est mieux ?",
    subtitle: "Comparez et voyez la différence",
    features: "Frais",
    airbnb: "Airbnb / Booking",
    traveltrok: "DONKEY TRAVEL",
    hostFees: "Frais Hôte",
    travelerFees: "Frais Voyageur",
    exchange: "Échange Gratuit",
  },
  testimonials: {
    title: "Ce que disent nos membres",
    subtitle: "Rejoignez une communauté qui change les règles",
    badge: "Témoignages",
    exchanges: "échanges",
    saved: "économisés",
    verifiedMembers: "+15 000 membres",
    completedExchanges: "+50 000 voyages",
    totalSaved: "0% de commission",
  },
  faq: {
    title: "Questions fréquentes",
    subtitle: "Tout ce que vous devez savoir sur nos tarifs",
    q1: {
      question: "Puis-je changer de plan à tout moment ?",
      answer:
        "Oui, vous pouvez passer à un plan supérieur à tout moment. La différence sera calculée au prorata de votre abonnement actuel.",
    },
    q2: {
      question: "Y a-t-il des frais supplémentaires ?",
      answer:
        "Non, aucun frais caché. Le prix affiché est le prix final que vous payez par an. Les échanges sont ensuite totalement gratuits.",
    },
    q3: {
      question: "Que se passe-t-il si je ne suis pas satisfait ?",
      answer:
        "Nous offrons une garantie satisfait ou remboursé de 30 jours. Si vous n'êtes pas satisfait, nous vous remboursons intégralement.",
    },
    q4: {
      question: "Comment fonctionne la facturation ?",
      answer:
        "Vous êtes facturé annuellement. Vous pouvez payer par carte bancaire ou virement. La facturation est automatique et vous recevez une facture par email.",
    },
    q5: {
      question: "Puis-je annuler mon abonnement ?",
      answer:
        "Oui, vous pouvez annuler à tout moment. Votre abonnement restera actif jusqu'à la fin de la période payée.",
    },
  },
  cta: {
    title: "Prêt à commencer l'aventure ?",
    subtitle:
      "Rejoignez des milliers de propriétaires qui voyagent gratuitement",
    createAccount: "Créer mon compte",
    exploreDestinations: "Explorer les destinations",
  },
  signup: {
    title: "Créer votre compte",
    subtitle: "Rejoignez notre communauté de propriétaires",
    firstName: "Prénom",
    lastName: "Nom",
    email: "Email",
    phone: "Téléphone",
    country: "Pays",
    selectCountry: "Sélectionnez votre pays",
    plan: "Plan",
    selectPlan: "Sélectionnez votre plan",
    propertyType: "Type de logement",
    selectPropertyType: "Sélectionnez le type de logement",
    terms:
      "J'accepte les conditions d'utilisation et la politique de confidentialité",
    submit: "Créer mon compte",
    success: "Compte créé avec succès !",
    error: "Une erreur est survenue. Veuillez réessayer.",
    securityNote: "Vos données sont sécurisées et ne seront jamais partagées",
    house: "Maison",
    apartment: "Appartement",
    villa: "Villa",
    loft: "Loft",
    other: "Autre",
  },
  signupSection: {
    title: "Rejoignez DONKEY TRAVEL aujourd'hui",
    subtitle:
      "Créez votre compte en quelques minutes et commencez à échanger votre logement avec des propriétaires du monde entier.",
    verifiedMembers: "Membres vérifiés",
    verifiedMembersDesc:
      "Tous nos membres sont des propriétaires Airbnb vérifiés pour des échanges en toute confiance.",
    guaranteedSavings: "Économies garanties",
    guaranteedSavingsDesc:
      "Nos membres économisent en moyenne 3 500€ par an sur leurs frais d'hébergement.",
    globalNetwork: "Réseau mondial",
    globalNetworkDesc:
      "Accédez à plus de 15 000 logements dans 85 pays à travers le monde.",
    responsiveSupport: "Assistance réactive",
    responsiveSupportDesc:
      "Notre équipe est disponible 7j/7 pour vous accompagner dans vos échanges.",
  },
  testimonialItems: {
    sophie:
      "Grâce à DONKEY TRAVEL, j'ai visité Barcelone, Rome et Amsterdam sans payer d'hébergement. La communauté est réactive et les discussions d'échange sont simples.",
    thomas:
      "J'ai rejoint l'offre de lancement 2026: -50% la première année. Le prix est garanti à vie pour les 1000 premiers, et j'échange partout en Europe.",
    marie:
      "J'ai enfin fait mon premier échange en Europe, et tout a été fluide du premier message jusqu'à l'arrivée. La vérification des profils aide vraiment.",
    pierre:
      "Pour nos logements, le tableau de bord nous fait gagner du temps: annonces, messages et disponibilités sont clairs et faciles à gérer.",
  },
};
